import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { openWa } from "@/lib/wa";

export default function Privacy() {
  const { pick } = useLang();

  const ar = (
    <div className="prose-mere" data-testid="privacy-content">
      <p><strong>آخر تحديث:</strong> يُراجع هذا النص ويُحدَّث وفق طريقة تشغيل الموقع الفعلية عند الحاجة.</p>
      <h2>المعلومات التي قد يدخلها العميل</h2>
      <p>نموذج طلب الخدمة في هذا الموقع يتيح لك إدخال بيانات اختيارية كالاسم ورقم التواصل وبيانات السيارة (النوع والموديل وسنة الصنع) ومقاس الإطار ووصف المشكلة وموقعك الجغرافي. جميع هذه الحقول تُستخدم لغرض واحد: تجهيز رسالة واتساب مرتبة ترسلها أنت بنفسك إلى ميرو.</p>
      <h2>الغرض من استخدام المعلومات</h2>
      <p>تُستخدم البيانات التي تدخلها في النموذج exclusively لتجهيز نص الرسالة المرسلة عبر واتساب. لا يقوم الموقع بحفظ هذه البيانات في قاعدة بيانات، ولا يستخدمها لأي غرض تسويقي، ولا يشاركها مع أي طرف ثالث.</p>
      <h2>التواصل عبر واتساب</h2>
      <p>اختيارك التواصل عبر واتساب اختياري تماماً؛ فعند الضغط على أي زر واتساب في الموقع يُفتح تطبيق واتساب لديك برسالة جاهزة يمكنك تعديلها قبل الإرسال. محادثة واتساب تخضع لسياسات الخصوصية الخاصة بمنصة واتساب.</p>
      <h2>بيانات الموقع الجغرافي</h2>
      <p>لا يطلب الموقع موقعك الجغرافي إلا بموافقتك الصريحة عند الضغط على زر مشاركة الموقع، ويُستخدم الموقع في تلك الحالة لإنشاء رابط خريطة يُرفق برسالة الواتساب لإفادة فريق التشغيل في تحديد مكانك. لا يُخزّن الموقع الجغرافي في أي قاعدة بيانات.</p>
      <h2>الاستفسارات المتعلقة بالخصوصية</h2>
      <p>لأي سؤال بخصوص الخصوصية أو طلبات تتعلق ببياناتك، تواصل معنا عبر واتساب أو الهاتف على الرقم 0507359999.</p>
      <h2>ملخص صريح</h2>
      <ul>
        <li>نموذج الطلب لا يحفظ بياناتك — بل يجهّز رسالة واتساب ترسلها بنفسك.</li>
        <li>لا نجمع بيانات موقعك إلا بموافقتك ولإرفاقها برسالتك فقط.</li>
        <li>لا نستخدم بياناتك لأغراض تسويقية ولا نشاركها مع أطراف ثالثة.</li>
      </ul>
    </div>
  );

  const en = (
    <div className="prose-mere" data-testid="privacy-content">
      <p><strong>Last updated:</strong> this text is reviewed and updated to match how the site actually operates.</p>
      <h2>Information you may enter</h2>
      <p>The service request form lets you optionally enter your name, phone number, car details (make, model, year), tire size, a problem description and your geographic location. All fields serve one purpose: composing a tidy WhatsApp message that you send yourself to MERO.</p>
      <h2>Purpose of use</h2>
      <p>The data you enter is used exclusively to compose the WhatsApp message. The site does not store this data in a database, does not use it for marketing and does not share it with third parties.</p>
      <h2>WhatsApp communication</h2>
      <p>Contacting us via WhatsApp is entirely optional. Tapping any WhatsApp button opens your WhatsApp app with a ready message you can edit before sending. WhatsApp chats are subject to WhatsApp's own privacy policies.</p>
      <h2>Location data</h2>
      <p>The site never requests your location without your explicit consent via the location-share button. When shared, your location is used only to attach a map link to your WhatsApp message so the crew can find you. The location is never stored.</p>
      <h2>Privacy enquiries</h2>
      <p>For any privacy question or request regarding your data, contact us on WhatsApp or by phone at 0507359999.</p>
      <h2>Straightforward summary</h2>
      <ul>
        <li>The form doesn't store your data — it composes a WhatsApp message you send yourself.</li>
        <li>Location is only collected with your consent and only to attach to your message.</li>
        <li>No marketing use, no third-party sharing.</li>
      </ul>
    </div>
  );

  return (
    <main>
      <SEO title="سياسة الخصوصية | ميرو للإطارات وخدمات السيارات" description="سياسة خصوصية موقع ميرو: كيف نتعامل مع البيانات التي تدخلها في نموذج طلب الخدمة، واستخدام واتساب، وبيانات الموقع الجغرافي." path="/privacy" />
      <PageHero eyebrow="PRIVACY" title={pick("سياسة الخصوصية", "Privacy policy")} sub={pick("شفافية كاملة في كيفية تعامل الموقع مع بياناتك.", "Full transparency about how this site handles your data.")} />
      <section className="pb-24">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <Reveal>{pick(ar, en)}</Reveal>
        </div>
      </section>
    </main>
  );
}
